export {default as EducationalPlanList} from "./List";
export {default as EducationalPlanExam} from "./Exam";
